/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import { createSlice } from '@reduxjs/toolkit';  
import { getAllOrgApplicationDevices, getAllOrgsAppsDevicesByOrgID, getOrgAppDeviceHistory } from './orgApplicationDevicesAction'; 
 
const initialState = {
    data: {},
    orgAppsDevicesList: {},
    orgAppDeviceHistory: {}
}
const orgApplicationDevicesSlice = createSlice({
    name: 'orgApplicationDevices',
    initialState,
    extraReducers: {

        [getAllOrgApplicationDevices.fulfilled]: (state, { payload }) => {
            state.orgAppsDevicesList =  payload;
        },
        [getAllOrgsAppsDevicesByOrgID.fulfilled]: (state, { payload }) => {
            state.orgAppsDevicesList =  payload;
        },
        [getOrgAppDeviceHistory.fulfilled]: (state, { payload }) => {
            state.orgAppDeviceHistory =  payload;
        },
        [getOrgAppDeviceHistory.rejected]: (state, { payload }) => {
            state.orgAppDeviceHistory =  {};
        },
    }
});

export default orgApplicationDevicesSlice.reducer